<div class="login_container_center">

  <div class="flex-container">
    <p class="left-text" style="font-size: 10pt; margin: 0; line-height: 13pt; position: absolute; left: 0;">Check-In time <br>
    {{detail?.checked_in_time}} </p>
    <img class="center-image" src="assets/img/guest-pass-logo.png" width="95" height="19" alt="" srcset="">
    @if (currentLanguage === 'eng') {
      <h4 class="right-text" style="position: absolute; right: 0;" (click)="changeLanguage('arb')"><strong>عربي</strong></h4>
    }
    @if (currentLanguage === 'arb') {
      <h4 class="right-text" (click)="changeLanguage('eng')"><strong>English</strong>
    </h4>
  }
</div>


<div  style="padding-left: 26px; padding-right: 26px;">
  <div class="ticket-container" >
    <p class="text-center">Your Car Details</p>
    <h2 class="text-center " style="margin-top: 10px; font-size: 18pt; font-weight: 500;"><strong>{{detail?.valet_vehicle?.plate_number_country_code }}
      {{detail?.valet_vehicle?.plate_number_prefix !== "" ? detail?.valet_vehicle?.plate_number_prefix : '' }} -
    {{detail?.valet_vehicle?.plate_number}}</strong></h2>
    <div style="display: flex; justify-content: space-evenly; align-items: center; margin-top: 20px;">
      <div style="width: 33%;  border-right: 1px solid black; padding: 0%;">
        <p class="text-center">Drop-off Location</p>
        @if (currentLanguage === 'eng') {
          <h3 class="text-center " style="margin-top: 10px; font-size: 14pt;"><strong>{{
          detail?.valet_location_dropoff?.title_en }}</strong></h3>
        }
        @if (currentLanguage === 'arb') {
          <h3 class="text-center " style="margin-top: 10px; font-size: 14pt;"><strong>{{
          detail?.valet_location_dropoff?.title_ar }}</strong></h3>
        }
      </div>
      <div style="width: 33%; border-left: 1px solid black; border-right: 1px solid black; padding: 0%;">
        <p class="text-center">Parked Location</p>
        @if (currentLanguage === 'eng') {
          <h3 class="text-center " style="margin-top: 10px; font-size: 14pt;"><strong>{{
          detail?.valet_location_parked?.title_en }}</strong></h3>
        }
        @if (currentLanguage === 'arb') {
          <h3 class="text-center " style="margin-top: 10px; font-size: 14pt;"><strong>{{
          detail?.valet_location_parked?.title_ar }}</strong></h3>
        }
      </div>
      <div style="width: 33%; border-left: 1px solid black; padding: 0%;">
        <p class="text-center">Key Slot</p>
        @if (currentLanguage === 'eng') {
          <h3 class="text-center " style="margin-top: 10px;">
            <strong>{{detail?.key_slot?.key_slot}}</strong>
          </h3>
        }
      </div>
    </div>


  </div>

  @if (detail?.ticket_payment_status === 'unpaid' && currentStep === 2) {
    <div class="ticket-container" style="padding: 10px 5px 5px 10px; margin-top: 5px;">
      <div style="display: flex; flex-direction: column; justify-content: center;">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <p class="" style="font-size: 14pt;">Amount</p>
          <h4 style="font-size: 16pt; font-weight: bold; color: #36BFEF;">{{detail?.currency}} {{detail?.amount}}</h4>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <p class="" style="font-size: 14pt;">Payment Method</p>
          @if (detail?.currency === 'KWD') {
            <div style="display: flex; align-items: center; justify-content: end;">
              <img src="assets/img/knet.png" height="19" alt="" srcset="">
              <h6 style="font-size: 14pt;">&nbsp;&nbsp;Knet</h6>
            </div>
          }
          @if (detail?.currency === 'BHD') {
            <div style="display: flex; align-items: center; justify-content: end;">
              <img src="assets/img/benefit.png" height="19" alt="" srcset="">
              <h6 style="font-size: 14pt;">&nbsp;&nbsp;Benefit Pay</h6>
            </div>
          }
          @if (detail?.currency === 'SAR') {
            <div style="display: flex; align-items: center; justify-content: end;">
              <img src="assets/img/mazda.png" height="19" alt="" srcset="">
              <h6 style="font-size: 14pt;">&nbsp;&nbsp;MADA</h6>
            </div>
          }
        </div>
      </div>
    </div>
  }





  <!-- Drop-off Location Dropdown -->
  @if (currentStep === 1 && dropOffLocations.length > 0) {
    <div style="margin-bottom: 15px;">
      <label style="display: block; font-size: 14pt; margin-bottom: 8px; font-weight: 500;">Select Drop-off Location:</label>
      <select [(ngModel)]="selectedDropOffLocationId"
        style="width: 100%; padding: 12px; font-size: 14pt; border: 1px solid #ddd; border-radius: 4pt; background-color: white;">
        @for (location of dropOffLocations; track location) {
          <option [value]="getLocationId(location)">
            {{ getLocationName(location) }}
          </option>
        }
      </select>
    </div>
  }

  @if (currentStep === 1) {
    <button (click)="vehicleDetail()" [disabled]="isRequestingCar"
      style="height: 50px; background-color: #36BFEF;color: white; border-radius: 4pt; border: none; width: 100%; font-size: 18pt; cursor: pointer;"
      [style.background-color]="isRequestingCar ? '#ccc' : '#36BFEF'"
      [style.cursor]="isRequestingCar ? 'not-allowed' : 'pointer'">
      @if (!isRequestingCar) {
        <span>{{ currentTranslation.requestMyCar }}</span>
      }
      @if (isRequestingCar) {
        <span>Requesting... <i class="fa fa-spinner fa-spin"></i></span>
      }
    </button>
  }

  <!-- Show Checkout button instead of direct payment -->
  @if (detail?.ticket_payment_status === 'unpaid' && currentStep === 2 && !showCheckoutUI && detail?.valet_site?.is_payment) {
    <button (click)="showCheckout()"
    style="height: 50px; background-color: #36BFEF;color: white; border-radius: 4pt; border: none; width: 100%; font-size: 18pt;">Checkout</button>
  }

  <!-- Checkout UI with Coupon functionality -->
  @if (showCheckoutUI && detail?.ticket_payment_status === 'unpaid' && currentStep === 2) {
    <div style="margin-top: 10px;">
      <!-- Ticket Summary -->
      <div class="ticket-container" style="padding: 15px; margin-bottom: 15px;">
        <h3 class="text-center" style="margin-bottom: 15px; font-size: 16pt; color: #36BFEF;"><strong>Checkout Summary</strong></h3>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <p style="font-size: 14pt; margin: 0;">Location:</p>
          @if (currentLanguage === 'eng') {
            <p style="font-size: 14pt; margin: 0; font-weight: bold;">{{detail?.valet_site?.title_en}}</p>
          }
          @if (currentLanguage === 'arb') {
            <p style="font-size: 14pt; margin: 0; font-weight: bold;">{{detail?.valet_site?.title_ar}}</p>
          }
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <p style="font-size: 14pt; margin: 0;">Check-In Time:</p>
          <p style="font-size: 14pt; margin: 0; font-weight: bold;">{{detail?.checked_in_time}}</p>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <p style="font-size: 14pt; margin: 0;">Original Amount:</p>
          <p style="font-size: 14pt; margin: 0; font-weight: bold; color: #36BFEF;">{{detail?.currency}} {{couponApplied ? couponResponse?.amount : detail?.amount}}</p>
        </div>
        <!-- Show discount details if coupon is applied -->
        @if (couponApplied) {
          <div style="border-top: 1px solid #ddd; padding-top: 10px; margin-top: 10px;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
              <p style="font-size: 14pt; margin: 0; color: #28a745;">Discount:</p>
              <p style="font-size: 14pt; margin: 0; font-weight: bold; color: #28a745;">-{{detail?.currency}} {{couponResponse?.total_discount_amount}}</p>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
              <p style="font-size: 16pt; margin: 0; font-weight: bold;">Total Amount:</p>
              <p style="font-size: 16pt; margin: 0; font-weight: bold; color: #36BFEF;">{{detail?.currency}} {{couponResponse?.discounted_amount}}</p>
            </div>
          </div>
        }
      </div>
      <!-- Coupon Code Section -->
      @if (!couponApplied) {
        <div class="ticket-container" style="padding: 15px; margin-bottom: 15px;">
          <h4 style="margin-bottom: 15px; font-size: 14pt; color: #36BFEF;"><strong>Have a Coupon Code?</strong></h4>
          <div style="display: flex; gap: 10px; align-items: flex-start;">
            <input
              type="text"
              [(ngModel)]="couponCode"
              placeholder="Enter coupon code"
              style="flex: 1; padding: 12px; border: 1px solid #ddd; border-radius: 4px; font-size: 14pt;"
              [disabled]="isApplyingCoupon">
            <button
              (click)="applyCoupon()"
              [disabled]="isApplyingCoupon || !couponCode.trim()"
              style="padding: 12px 20px; background-color: #28a745; color: white; border: none; border-radius: 4px; font-size: 14pt; cursor: pointer;"
              [style.background-color]="isApplyingCoupon || !couponCode.trim() ? '#ccc' : '#28a745'">
              {{isApplyingCoupon ? 'Applying...' : 'Apply'}}
            </button>
          </div>
          <!-- Error message -->
          @if (couponError) {
            <p style="color: #dc3545; margin-top: 10px; font-size: 12pt;">{{couponError}}</p>
          }
        </div>
      }
      <!-- Applied Coupon Display -->
      @if (couponApplied) {
        <div class="ticket-container" style="padding: 15px; margin-bottom: 15px; background-color: #d4edda; border: 1px solid #c3e6cb;">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <p style="margin: 0; font-size: 14pt; color: #155724;"><strong>✓ Coupon Applied: {{couponCode}}</strong></p>
            <p style="margin: 0; font-size: 14pt; color: #155724; font-weight: bold;">Saved {{detail?.currency}} {{couponResponse?.total_discount_amount}}</p>
          </div>
        </div>
      }
      <!-- Payment Button -->
      <button
        (click)="proceedToPayment()"
        style="height: 50px; background-color: #36BFEF; color: white; border-radius: 4pt; border: none; width: 100%; font-size: 18pt; margin-bottom: 10px;">
        {{couponApplied && couponResponse?.discounted_amount === '0.000' ? 'Complete Order (Free)' : 'Pay ' + detail?.currency + ' ' + (couponApplied ? couponResponse?.discounted_amount : detail?.amount)}}
      </button>
    </div>
  }

  @if (currentStep === 1) {
    <div class="text-center" style="margin-top: 10px;">
      <a href="#" class="text-center"
      style="color: black; text-align: center; text-decoration: underline; font-size: 14pt;" >Terms & Conditions</a>
    </div>
  }
</div>




<div class="stepper" style="margin-top: 30px;">
  <!-- Step 1 -->
  <div class="step" [ngClass]="{'completed': currentStep >= 1}">
    <div class="circle">{{ currentStep >= 1 ? '✔' : '' }}</div>
    <p>Parked</p>
  </div>

  <div class="line" ></div>

  <!-- Step 2 -->
  <div class="step" [ngClass]="{'completed': currentStep >= 2}">
    <div class="circle">{{ currentStep >= 2 ? '✔' : '' }}</div>
    <p>Requested</p>
  </div>

  <div class="line" ></div>

  <!-- Step 3 -->
  <div class="step" [ngClass]="{'completed': currentStep >= 3}">
    <div class="circle">{{ currentStep >= 3 ? '✔' : '' }}</div>
    <p>On its way</p>
  </div>

  <div class="line" ></div>

  <!-- Step 4 -->
  <div class="step" [ngClass]="{'completed': currentStep >= 4}">
    <div class="circle">{{ currentStep >= 4 ? '✔' : '' }}</div>
    <p>Arrived</p>
  </div>

</div>
<img src="assets/img/guest.png" alt="" style="width: 100%; height: 205px; position: absolute; bottom: 0;" srcset="">


</div>
